import { Component, HostListener, OnInit } from '@angular/core';
import { faArrowRight, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-subscription-benefits',
  templateUrl: './subscription-benefits.component.html',
  styleUrls: ['./subscription-benefits.component.scss',],
})
export class SubscriptionBenefitsComponent implements OnInit {

  subscriptionTable: string[] = [];

  showAll = false;
  faCheck = faCheck;
  faTimes = faTimes;
  faArrowRight = faArrowRight;

  constructor(private _$gaService: GoogleAnalyticsService) { }

  @HostListener('window:resize', ['$event',])
  onResize(_event: Event) {
    this.isSmallScreen();
  }

  ngOnInit(): void {
    this.isSmallScreen();
  }

  isSmallScreen() {
    this.subscriptionTable = [
      'Zero Down Payment & Road Tax',
      'No Financing Process',
      'Cheaper than EMI',
      'Annual Insurance Included',
      'Free Car Service & Maintenance',
      'Free 24x7 All India Road Side Assistance',
      ...window.innerWidth > AppConstants.SMALL_SCREEN || this.showAll ? [
        'End to End Warranty',
        'Doorstep Pick & Drop for Service & Maintenance',
        'Hassle Free Insurance Claims',
        'Stress Free Car Maintenance',
        'Wide Range of PPP Certified Cars to Choose',
        'Flexible Tenure & Easy Extension Process',
        'No Dealer Visit at Time of Purchase/Sale',
      ] : [],
    ];
  }


  browseCarClick(_event: Event) {
    this._$gaService.event('button_click', 'browse_car', 'Subscription Benefits Browse Car');
  }

}
